export default __webpack_public_path__ + "static/media/this-is-your-home-2.6d21f4ca.webp";